import './footer.scss';

import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ounic from '../../assets/brand/ounic.svg';
import { copyrightYear, footerServices, siteContact, siteTagline, socialLinks } from '../../content';
import { NewsletterSubscribe } from './NewsletterSubscribe';

export const Footer = () => {
  return (
    <footer className="footer pt-5 pb-4 pb-lg-5 mt-2 mt-md-0 background">
      <div className="container pt-lg-4">
        <div className="row pb-5">
          <div className="col-lg-4 col-md-6">
            <div className="navbar-brand text-dark p-0 me-0 mb-3 mb-lg-4">
              <img src={ounic} alt="Ounic logo" width={80} />
            </div>
            <p className="pb-lg-3 mb-4 text-dark footer-tagline">{siteTagline}</p>
            <NewsletterSubscribe />
          </div>
          <div className="col-xl-7 col-lg-7 col-md-5 offset-2 offset-md-1 pt-4 pt-md-1 pt-lg-0">
            <div id="footer-links" className="row">
              <div className="col-lg-5">
                <h6 className="mb-2 footer-column-title">Our Services</h6>
                <div id="useful-links" className="collapse d-lg-block footer-services" data-bs-parent="#footer-links">
                  <ul className="nav flex-column pb-lg-1 mb-lg-3">
                    {footerServices.map((service) => (
                      <li key={service} className="nav-item service d-inline-block px-0 pt-1 pb-2">
                        {service}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="col-xl-4 col-lg-4 pt-2 pt-lg-0">
                <h6 className="mb-2 footer-column-title">Our Links</h6>
                <ul className="nav flex-column pb-lg-2 mb-lg-3 pt-lg-2">
                  {socialLinks.map((link) => (
                    <li key={link.url} className="nav-item address">
                      <a href={link.url} style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
                        <span className="addressBook">
                          <FontAwesomeIcon icon={solid('at')} />
                        </span>
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="col-xl-3 col-lg-3 pt-2 pt-lg-0">
                <h6 className="mb-2 footer-column-title">Contact us</h6>
                <ul className="nav flex-column pb-lg-1 mb-lg-3">
                  <li className="nav-item address company">{siteContact.company}</li>
                  <li className="nav-item address">{siteContact.address}</li>
                  <li className="nav-item address">
                    <span className="addressBook">
                      <FontAwesomeIcon icon={regular('address-book')} />
                    </span>
                    {siteContact.phone}
                  </li>
                  <li className="nav-item address">
                    <span className="addressBook">
                      <FontAwesomeIcon icon={solid('at')} />
                    </span>
                    {siteContact.email}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <p className="text-center text-md-start pb-2 pb-lg-0 mb-0">
          <a className="nav-link d-inline-block p-0" href="/" target="_blank" rel="noopener noreferrer">
            &copy; {copyrightYear}
          </a>
        </p>
      </div>
    </footer>
  );
};
